module.exports = __webpack_public_path__ + "./images/81d80913b904e5d114c472921ea3ea78.webp";